import store from '@/store';

export default (to, from, next) => {
    const is_anonymous_recharge_allowed = store.getters.is_app_anonymous_recharge_allowed;

    return {
        allow: is_anonymous_recharge_allowed,
        redirect: { name: 'not-found' },
    }
};
